import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const familyFoldersInShared = isFeature('family-folders-in-shared');
